import { useGetEuroFxQuery } from '../types/generated';

export function useConvertCurrency() {
  const fxRates = useGetEuroFxQuery();

  function convert(amount: number, toCurrency: string) {
    if (toCurrency === 'EUR') return amount;
    const rate = fxRates.data?.euroFx.find(
      (dailyRate) => dailyRate.currency === toCurrency,
    );

    if (!rate) {
      console.warn(`Unable to find exchange rate for EUR-${toCurrency}`);
      return amount;
    }

    return amount * rate.value;
  }

  return {
    convert,
  };
}
